export default {
  'dbi-sm-data-summary': '数据量级总结',
  'dbi-sm-historical-magnitude': '游戏总量级',
  'dbi-sm-monthly-updated-games': '月更游戏量级',
  'dbi-sm-countries-coverage': '国家覆盖',
  'dbi-sm-data-sources': '数据源',
  'dbi-sm-top-games-coverage': '头部游戏覆盖率',
  'dbi-sm-company-coverage': '头部游戏公司覆盖率',
  'dbi-sm-news': '新闻',
  'dbi-sm-social-media-opinions': '社媒舆情',
  'dbi-sm-game-store-comments': '游戏商店评论',
  'dbi_sm_revenue_heat_map': '收入热力图',
  'dbi_sm_all_games': '全部游戏',
  'dbi_sm_MOBILE': '头部手游',
  'dbi_sm_PC': '头部端游',
  'dbi_sm_CONSOLE': '头部主机游戏',
  'dbi_sm_top_company': '头部公司',

  'dbi-sm-sources': '数据源',
  'dbi-sm-intelligence-sources': '情报数据源',
  'dbi-sm-opinions-sources': '舆情数据源',
  'dbi-sm-news-crawlers': '新闻数据源',
  'dbi-sm-metrics': '指标',
  'dbi-sm-intelligence-metrics': '情报指标',
  'dbi-sm-opinions-metrics': '舆情指标',
  'dbi-sm-mobile-game-fields': '手游字段',
  'dbi-sm-PC&Console': 'PC及主机游戏字段',
  'dbi-sm-company-fields': '公司字段',
  'dbi-sm-device-metrics': '设备指标',

  'dbi-sm-filter-datasource': '数据源',
  'dbi-sm-filter-gametype': '游戏类型',
  'dbi-sm-filter-metrics': '游戏指标',
  'dbi-sm-filter-servicetype': '获取方式',
  'dbi-sm-filter-channeltype': '渠道类型',
  'dbi-sm-filter-granularity': '时段粒度',
  'dbi-sm-filter-frequency': '更新频次',
  'dbi-sm-filter-gamestore': '游戏商店',
  'dbi-sm-filter-socialmedia': '社交媒体',
  'dbi-sm-filter-streaming': '直播',

  'dbi-sm-filter-hour': '小时',
  'dbi-sm-filter-quarter': '季',
  'dbi-sm-filter-alltime': '全部',

  'dbi-sm-filter-acquisition': '数据采买',
  'dbi-sm-filter-crawling': '数据爬取	',

  'dbi-sm-filter-mobile': '手游',
  'dbi-sm-filter-pc': '端游',
  'dbi-sm-filter-console': '主机游戏',

  'dbi-sm-table-description': '内容描述',
  'dbi-sm-table-progress': '获取进度',
  'dbi-sm-table-sourceurl': '官网',
  'dbi-sm-table-summary': '服务宗旨',
  'dbi-sm-table-industry-coverage': '行业覆盖',
  'dbi-sm-table-rawdata': '数据来源',
  'dbi-sm-table-profitmodel': '盈利模式',
  'dbi-sm-table-datausage': '数据使用方式',
  'dbi-sm-table-note': '备注',
  'dbi-sm-table-dateupdate': '数据更新频次',
  'dbi-sm-table-actions': '操作',

  'dbi-sm-table-monitored': '监控游戏数量',
  'dbi-sm-table-monthlyupdate': '月更游戏量级	',
  'dbi-sm-table-totalgames': '游戏总量级',
  'dbi-sm-table-comment': '月更新评论数',
  'dbi-sm-table-feature': '数据源特点',
  'dbi-sm-table-engagement': '指标/模块',
  'dbi-sm-table-availability': '是否可用',
  'dbi-sm-table-url': 'url',

  'dbi-sm-table-servicemodel': '服务模式',

  'dbi-sm-table-definition': '指标定义',
  'dbi-sm-table-countries': '覆盖区域',
  'dbi-sm-table-historical': '覆盖历史数据时间段',
  'dbi-sm-table-metrics-cn': '中文名称',
  'dbi-sm-table-datagranularity': '数据粒度',

  'dbi-sm-table-fieldsName': '游戏属性字段',
  'dbi-sm-table-fieldsdefinition': '游戏属性字段',
  'dbi-sm-table-aggregation': '字段计算逻辑',
  'dbi-sm-games-coverage-tip': `头部游戏:当月有登榜各大游戏商店榜单的游
  戏。手游榜单来自Appstore和
  Googleplay; 端游榜单来自Steam;
  Console榜单来自Xbox`,
  'dbi-sm-company-coverage-tip': `头部公司: 当月头部游戏对应的公司`,
  'dbi-sm-filter-fieldsName': '数据库字段',
  'dbi-sm-filter-description': '字段描述',
  'dbi-sm-filter-aggregation': '字段计算逻辑',
  'dbi-sm-device-metrics-table-metric': '指标',
  'dbi-sm-device-metrics-table-definition': '定义',
  'dbi-sm-device-metrics-table-description': '备注',



  'dbi-sm-revenue': '收入',
  'dbi_sm_mobile_game_field_info1': '1. 当前数据获取源有Crowdsourcing, App Store, Google Play, data.ai, Sensor Tower, Taptap.',
  'dbi_sm_mobile_game_field_info2': '3. 字段选择的数据源默认优先级为Crowdsourcing＞App Store＞Google Play＞data.ai＞Sensor Tower＞Taptap',
  'dbi_sm_mobile_game_field_info3': '3. 无需排序的字段，字段取所有数据源数据的并集。',
  'dbi_sm_pc_game_field_info1': '1. PC数据源 Crowdsourcing, Steam, Vgchartz, Metacritic, Epgame, Vgtime, Gog, Origin, Opencritic; Console数据源 Crowdsourcing, Vgchartz, Metacritic, Xbox, Vgtime.',
  'dbi_sm_pc_game_field_info2': '2. PC的默认优先级 Crowdsourcing＞Steam＞Metacritic > Vgchartz > Gog > Opencritic > Origin > Epic Game > Vgtime',
  'dbi_sm_pc_game_field_info3': '3. Console的默认优先级 Crowdsourcing＞Vgchartz＞Metacritic＞Vgtime > Xbox > Opencritic > Nintendo',
  'dbi_sm_pc_game_field_info4': '4. 无需排序的字段内容，字段取所有数据源数据的并集。',
  'dbi_sm_company_field_info1': '1. 公司数据源优先级：Crowdsouring＞Crunchbase＞data.ai＞Gamedevmap＞Gamebiz＞Mobygames > Pitchbook > Local > Spider',
  'dbi_sm_company_field_info2': '2. Crowdsouring为手动添加的白名单或特别关注个体，强制执行更新。',
  'dbi_sm_company_field_info3': '3. 以Crunchbase为主，因其字段较全。Mobile游戏以App annie核心字段进行辅助校准，以确保开发商信息正确。',
}
